document.addEventListener("DOMContentLoaded", function () {
    // Seleciona todos os elementos de checkbox dentro da classe bundle-product-checkbox
    const checkboxes = document.querySelectorAll('.available .bundle-product-checkbox input[type="checkbox"]');

    // Adiciona um listener de evento para cada checkbox
    checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            updateTotalPrice();
        });
    });

    // Seleciona todos os cards de produto
    const productCards = document.querySelectorAll('.bundle-product-item');

    // Adiciona um listener de evento para cada card de produto
    productCards.forEach(function (card) {
        card.addEventListener('click', function () {
            // Encontra o checkbox dentro deste card de produto
            const checkbox = card.querySelector('input[type="checkbox"]');
            // Inverte a classe isChecked no elemento do card de produto
            card.classList.toggle('isChecked');
            // Inverte o estado do checkbox (marca se estiver desmarcado, desmarca se estiver marcado)
            checkbox.checked = !checkbox.checked;
            // Atualiza o preço total
            updateTotalPrice();
        });
    });

    // Função para atualizar o preço total
    function updateTotalPrice() {
        // Variável para armazenar o preço total
        let totalPrice = 0;
        // Variável para verificar se algum produto está selecionado
        let anyProductSelected = false;
        // Loop através de todos os checkboxes para calcular o preço total
        checkboxes.forEach(function (checkbox) {
            // Verifica se o checkbox está marcado
            if (checkbox.checked) {
                // Obtém o preço do produto associado ao checkbox marcado
                const price = parseFloat(checkbox.parentElement.nextElementSibling.querySelector('[data-bundle-product-price]').innerText.replace("R$", "").trim());
                // Adiciona o preço ao preço total
                totalPrice += price;
                // Marca que algum produto está selecionado
                anyProductSelected = true;
            }
        });

        // Atualiza o texto do preço total
        const totalPriceElement = document.querySelector('[data-bundle-product-total]');
        if (anyProductSelected && totalPrice > 0) {
            totalPriceElement.style.display = 'block';
            totalPriceElement.innerText = "R$ " + totalPrice.toFixed(2);
        } else {
            totalPriceElement.style.display = 'none';
        }

        // Verifica se o preço total é igual a 0
        const messageBox = document.querySelector('#message-box');
        if (totalPrice === 0) {
            // Se o preço total for 0, exibe a mensagem
            messageBox.style.display = 'block';
            document.querySelector('[data-bundle-addtocart]').style.display = 'none';
        } else {
            // Se o preço total for maior que 0, oculta a mensagem
            messageBox.style.display = 'none';
            document.querySelector('[data-bundle-addtocart]').style.display = 'block';
        }
    };
});

document.querySelector('.bundle-product > form').addEventListener('submit', function (e) {
    e.preventDefault();
    e.target.querySelector('.button-bundle').classList.add('is-loading');

    const checkboxes = document.querySelectorAll('.available .bundle-product-checkbox input[type="checkbox"]');
    Shopify.queue = [];

    checkboxes.forEach(function (checkbox) {
        if (checkbox.checked) {
            const variantId = $($($(checkbox).parents('.bundlePdItem-container')).children('input')).val()
            if (variantId) Shopify.queue.push({ variantId: variantId, quantity: 1 });
        }
    });

    Shopify.moveAlong = function () {
        if (Shopify.queue.length) {
            var request = Shopify.queue.shift();
            let dataForm = 'quantity=' + request.quantity + '&id=' + request.variantId;
            var params = {
                type: 'POST',
                url: '/cart/add.js',
                data: dataForm,
                dataType: 'json',
                beforeSend: function () {
                    console.log(dataForm)
                },
                success: function (line_item) {
                    Shopify.moveAlong()
                },
                error: function (XMLHttpRequest, textStatus) {
                    console.log("Erro ao adicionar")
                }
            }
            $.ajax(params);
        } else {
            $(e.target.querySelector('.button-bundle')).removeClass('is-loading');
            Shopify.getCart((cartTotal) => {
                $('body').addClass('cart-sidebar-show');
                $('body').find('[data-cart-count]').text(cartTotal.item_count);
                window.updateCart(cartTotal);
            })
        }
    };

    Shopify.moveAlong();
});